import { useAuth } from '../hooks';
import { Link, useNavigate } from 'react-router-dom';
import { TrendStatsCard } from '../components/core/dashboard/TrendStatsCard';
import React, { useState, useEffect } from 'react';
import { Progress } from '../components/core/dashboard/ProgressComponent';
import BudgetHistoryWidget from '../components/expense/BudgetHistoryWidget';
import { BarChart} from '../components/core/dashboard/BarChart';
import { PieChart } from '../components/core/dashboard/PieChart';
import { TransactionInfo } from '../components/core/dashboard/TransactionCardInfo';
import { expenseService, invoiceService, profileService } from '../services';
import {
  CustomerIcon,
  NariaIcon,
  TitleIcon,
  TransactionIcon,
} from '../assets/icons';
import PageLoader from '../components/common/PageLoader';
import { Transaction, DashboardStats} from '../@types';
import { CashBalanceIcon } from '../assets/icons/cashBalanceIcon';
import ArrowSelectIcon from '../assets/icons/arrowSelectIcon';
import { getBudgetHistory } from '../backend-services';
import { InvoicePieChart } from '../components/core/dashboard/PieChart/InvoiceStatusPieChart';
import { formatMoney } from '../utils';
import { useExpenseStore } from '../state';
import { useUserStore } from '../state/useUserStore';
import EmptyStateChart from '../components/core/dashboard/BarChart/Empty';
import { ExpensePieChart } from '../components/core/dashboard/PieChart/expense';
import BudgetHistory from '../components/core/dashboard/BudgetHistory';
import SubscriptionBanner from '../components/Subscription/SubscriptionBanner';


export const DashboardPage = () => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [dashboardStats, setDashboardStats] = useState<DashboardStats>({
    invoices: { totalInvoices: 0, totalPaidInvoiceValue: 0, totalUnPaidInvoiceValue: 0 },
    expenses: { totalExpenses: 0, totalBillableExpenseValue: 60000, totalNonBillableExpenseValue: 35000 },
    cashflowTrend: {
      trend: {
        jan: { invoice: 0, expense: 0, },
        feb: { invoice: 0, expense: 0,  },
        mar: { invoice: 0, expense: 0 },
        apr: { invoice: 0, expense: 0 },
        may: { invoice: 0, expense: 0 },
        jun: { invoice: 0, expense: 0 },
        jul: { invoice: 0, expense: 0 },
        aug: { invoice: 0, expense: 0 },
        sep: { invoice: 0, expense: 0 },
        oct: { invoice: 0, expense: 0 },
        nov: { invoice: 0, expense: 0 },
        dec: { invoice: 0, expense: 0 },
      },
      fill: { invoice: '#37C89A', expense: '#EB5757' },
    },
    cashBalance: { isIncreasing: false, value: 0 },
    customers: { isIncreasing: false, value: 0 },
    expenseCategories: {
      Equipments: { value: 0, fill: '' },
      Automobiles: { value: 0, fill: '' },
      Logistics: { value: 0, fill: '' },
      Rent: { value: 0, fill: '' },
    },
    invoiceStatuses: {
      totalOverDueInvoices: 0,
      totalPaidInvoices: 0,
      totalDraftInvoices: 0,
      totalPendingInvoices: 0,
      overdue: { value: 0, fill: '' },
      paid: { value: 0, fill: '' },
      draft: { value: 0, fill: '' },
      pending: { value: 0, fill: '' },
      cancelled: { value: 0, fill: '' },
    },
    transactions: {
      isIncreasing: false,
      value: 0,
      totalExpenses: 0,
      totalInvoices: 0,
      expense: { value: 0, fill: '' },
      invoice: { value: 0, fill: '' },
    },
  });
  const navigate = useNavigate();
  const { cognitoUser } = useAuth(navigate);
  const [dropdown, setDropdown] = useState(false);
  const[showBanner, setShowBanner] = useState<boolean>(true)
  const [bannerMessage, setBannerMessage] = useState<string>('');

  const { user, fetchUserProfile } = useUserStore();
 
  React.useEffect(() => {
    const fetchUserProfileData = async () => {
      await fetchUserProfile();
    };

    fetchUserProfileData();
  }, [fetchUserProfile]);

  const closeShowBanner = () => {
    setShowBanner(false)
  }


  const isSmallScreen = () => {
    return window.innerWidth < 768;
  };
  useEffect(() => {
    const fetchTransactions = async () => {
      setIsLoading(true);

      try {
        const [invoices, expenses, stats] = await Promise.all([
         invoiceService.get(`/invoices?`),
      expenseService.get(`/expenses?limit=${2}`),
      profileService.get(`/companies/stats?limit=${4}`),
        ]);

        const mergedTransactions: Transaction[] = [
          ...invoices.data.data
            .map((invoice: any) => ({
              data: { ...invoice, type: 'invoice' },
            })),
           

          ...expenses.data.data
            .map((expense: any) => ({
              data: { ...expense, type: 'expense' },
            }))
           
        ];

        const sortedTransactions = mergedTransactions.sort(
          (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
  
        setTransactions(sortedTransactions);
        setDashboardStats(stats.data as unknown as DashboardStats);
        setIsLoading(false);
      } catch (e) {
        setError('Error fetching transactions.');
        setIsLoading(false);
      }
    };
  
    fetchTransactions();
  }, []);

  const getBudget = React.useCallback(async () => {
    const date = new Date().toISOString();
    const startMonthYear = date.split('T')[0].slice(0, 7).split('-').reverse().join('-');
    const endMonthYear = date.split('T')[0].slice(0, 7).split('-').reverse().join('-');
    return await getBudgetHistory(startMonthYear, endMonthYear);
  }, []);



  useEffect(() => {}, [dashboardStats]);

  if (isLoading) {
    return <PageLoader></PageLoader>;
  }

  if (error) {
    return <div>{error}</div>;
  }
  
  const type: string = "invoice";
 
 
  const cashflowTrendData = dashboardStats.cashflowTrend.trend as Record<string, { invoice: number; expense: number }>;

const hasData = Object.values(cashflowTrendData).some(
  (dataPoint) => dataPoint.invoice !== 0 || dataPoint.expense !== 0
);

  

  return (
    <>
    <div className='h-screen  xl:mb-[em] relative'>
    <div className='absolute  top-[-40px] z-20'>
          {showBanner && <SubscriptionBanner message={bannerMessage} onClose={closeShowBanner}/>}
       </div>
      <div className="md:max-xl:flex flex  lg:justify-between lg:mt-[35px] xl:justify-between xl:mt-[53px] items-center">
        <h2 className="flex justify-start text-[18px] 375:ml-[-2em] 414:ml-[-1em] mt-[3em] 360:ml-[-2.5em] 412:ml-[-0.8em] 540:ml-[0.3em]  md:text-[20px] pb-[1em] md:ml-[0.3em] bigmd:ml-[0.4em] md:pb-[1em] lg:ml-[0.2em] biglg:ml-[0.2em]  xl:ml-[0.1em] lg:mt-[20px] xl:font-medium xl:leading-7 xl:text-[ #000000] xl:text-[24px] xl:mt-[1em]" style={{ whiteSpace: 'nowrap' }}>Hello {user.firstName},</h2>
        <div className="float-left overflow-hidden hidden sm:block lg:mt-[-4em] xl:mt-[-2.5em] md:mt-[-2.5em]  md:ml-[3em] bigmd:mt-[-2.5em] bigmd:ml-[12em]">
          <div className=''>
            <button
            className="lg:bg-[#044E97] md:bg-[#044E97] xl:mt-[-0.04em] xl:bg-[#044E97] lg:text-[#FFFFFF] md:ml-[18em] md:text-[#FFFFFF] md:text-[16px] lg:text-[16px] lg:flex  md:flex lg:items-center md:w-[215px] md:mt-[4em] lg:w-[239px] lg:h-[47px] md:py-[12.5px]  md:h-[47px] lg:gap-[53px] md:gap-[33px] lg:py-[12.5px] lg:pl-[19px]  md:pl-[19px] lg:leading-4 md:leading-4 lg:rounded  md:rounded first-letter:lg:font-semibold  xl:w-[239px] xl:h-[47px] xl:font-semibold xl:leading-4 xl:rounded xl:text-[#FFFFFF] xl:text-[16px] xl:flex xl:items-center xl:gap-[53px] xl:py-[30.5px] xl:pl-[19px]"
            onClick={() => setDropdown((prev) => !prev)}
          >
            New Transanction {<ArrowSelectIcon />}
          </button>
          </div>
          
          {dropdown ? (
            <div className="md:shadow-[0px 8px 16px 0px rgba(0,0,0,0.2)] md:ml-[18em] md:w-[215px] lg:shadow-[0px 8px 16px 0px rgba(0,0,0,0.2)] lg:w-[240px] xl:w-[240px] md:bg-[#ffff] lg:bg-[#ffff] xl:bg-[#ffff] xl:pt-[15px] xl:shadow-[0px 8px 16px 0px rgba(0,0,0,0.2)] xl:z-[1] xl:absolute">
              <h3 className="">
                <Link to={'/invoices/create'} className=" md:text-[#000] md:px-[16px] lg:text-[#000] lg:px-[16px] xl:text-[#000]  xl:px-[16px]">
                  New Invoice
                </Link>
              </h3>
              <h3 className="md:text-[#000] md:py-[12px] md:px-[16px] lg:text-[#000] lg:py-[12px] lg:px-[16px] xl:text-[#000] xl:py-[12px] xl:px-[16px]">
                <Link to={'/expenses/create'}>New Expense</Link>
              </h3>
            </div>
          ) : (
            '' 
          )}
        </div>
      </div>

          <div className='flex flex-col justify-center lg:flex-row  items-center gap-[21px] relative lg:w-full lg:mt-0 xl:mt-0 2xl:mt-0'>
            <div className='relative lg:h-[485px] rounded-[4px] bg-white lg:w-[40%] w-[350px] md:w-[100%] 540:w-[100%]' >
            <TrendStatsCard
            title="Cash Balance"
            titleIcon={<CashBalanceIcon />}
            trendIcon={''}
            amount={formatMoney(dashboardStats?.cashBalance?.value)}
            trendtitle="Last 30 days"
            isUpTrend={dashboardStats?.cashBalance.isIncreasing}
            amountClassName={dashboardStats?.cashBalance.value < 0 ? 'text-red-500' : ''}
          />

          <hr className='xl:ml-[-1em] xl:mr-[-1em]'/> 
          <TrendStatsCard
            title="New Customer"
            titleIcon={<CustomerIcon />}
            trendIcon={''}
            amount={dashboardStats.customers.value}
            trendtitle=""
            isUpTrend={dashboardStats?.customers.isIncreasing}
          />
          <hr className='xl:ml-[-1em] xl:mr-[-1em]'/>
          <TrendStatsCard
            title="Transactions"
            titleIcon={<TransactionIcon />}
            trendIcon={''}
            amount={dashboardStats.transactions.value}
            trendtitle=""
            isUpTrend={dashboardStats?.transactions.isIncreasing}
          />
        </div>
        <div className="relative md:hidden top-[-1em] left-[9em] 540:left-[12em] z-10">
  <button
    className=" bg-[#044E97] text-[#FFFFFF] text-[16px] flex  w-9 h-9 rounded-full justify-center items-center  py-[12.5px]  leading-4  first-letter font-semibold absolute "
    onClick={() => setDropdown((prev) => !prev)}
  >
    {dropdown ? (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  stroke="currentColor"
  className="w-6 h-6 inline-block items-center"
>
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
   d="M6 18L18 6M6 6l12 12"
  />
</svg>
) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        className="w-6 h-6 inline-block"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
        />
      </svg>
    )}
  </button>
  {dropdown ? (
    <div className="shadow-[0px 8px 16px 0px rgba(0,0,0,0.2)] w-[240px]  bg-[#ffff] pt-[15px] shadow-[0px 8px 16px 0px rgba(0,0,0,0.2)] absolute bottom-[50px] ml-[-7em] mb-[-3em] ">
      <h3 className="">
        <Link to={'/invoices/create'} className="text-[#000]  px-[16px]">
          New Invoice
        </Link>
      </h3>
      <h3 className="text-[#000] py-[12px] px-[16px] ">
        <Link to={'/expenses/create'}>New Expense</Link>
      </h3>
    </div>
  ) : (
    '' 
  )}
</div>
        <div className='relative lg:h-[481px] rounded-[4px] bg-white lg:w-[60%] md:w-[100%] 540:w-[100%] w-[350px]  h-[400px] mt-[-1.5em] md:mt-[0.5em] lg:mt-0 xl:mt-0 2xl:mt-0 biglg:mt-0 '>
          <TransactionInfo transactions={transactions} type={type} recentCount={4} />
        </div>
      </div>
    
         <div className='flex flex-col lg:flex-row justify-center lg:bg-white lg:flex  2xl:items-center 2xl:flex-none xl:flex-none lg:flex-none xl:items-center  lg:items-center lg:mt-[1em] xl:mt-[1em] xl:flex  2xl:gap- lg:h-[721px] xl:h-[721px]'>
          <div className=' mt-[1em] 390:ml:[-2.7em] 375:ml-[-2.4em] 414:ml-[-1.3em] 360:ml-[-2.8em] 412:ml-[-1.3em] 540:ml-[-0.1em]  flex justify-center bg-white  lg:mt-0 xl:mt-0 2xl:mt-0 items-center sm:block w-[350px] 540:w-[100%]  md:mt-[2em] md:w-[100%] md:h-[363px] md:ml-[0.1em] lg:w-[40%] xl::w-[40%] 2xl:w-[40%] 3xl:w-[40%] lg:flex-grow xl:flex-grow xl:h-[640px] xl:flex-initial 2xl:flex'>
          <PieChart
            title="Transaction Type"
            trendIcon={''}
            trendtitle="Last 30 days"
            isLoaded={true}
            labelPosition="bottom"
            totalName="Total Transactions"
            pieChartInnerRadius={72}
            totalValue={dashboardStats.transactions.value}
            data={dashboardStats.transactions }
          />
        </div>
        <div className="mt-[1em] 390:ml:[-2.7em] 375:ml-[-2.4em] 414:ml-[-1.3em] 360:ml-[-2.8em] 412:ml-[-1.3em] 540:ml-[-0.1em]  h-[600px]  md:mt-[2em] bg-white 540:w-[100%] w-[350px] md:w-[100%] md:h-[693px] 2xl:ml-[-3.5em]  lg:ml-[-2.5em]  xl:ml-[-2.5em] 3xl:ml-[1em] md:ml-[0.2em] xl:flex  lg:w-[60%] xl:w-[60%] 2xl:w-[60%] 3xl:w-[60%]  xl:mt-[1em] lg:mt-[1em] lg:flex-grow 2xl:flex-col  lg:flex-col  xl:flex-col xl:flex-grow   ">
          <Progress
            icon={<NariaIcon />}
            title="Invoices"
            value="Last 30 days"
            valueIcon={''}
            text="Total Number of Invoices"
            totalNumber={dashboardStats.invoices.totalInvoices}
            data={dashboardStats.invoices}
          />
          <hr className="lg:flex lg:my-[30px] lg:pl-[2em] my-[10px] px-[10em] flex" />
          <div className='xl:mt-[-1em]'>
          <Progress
            icon={<TitleIcon />}
            title="Expenses"
            value=""
            valueIcon={''}
            text="Total Number of Expenses"
            totalNumber={dashboardStats.expenses.totalExpenses}
            data={dashboardStats.expenses}
          />
          </div>
          <hr className="border lg:flex lg:my-[30px] lg:px-[20em] my-[10px] px-[10em] flex " />
          <div className=' w-[255px] ml-[1em]  md:mt-[-1em] md:w-[608px]  md:ml-[1em] xl:mt-[-1em] lg:mt-[1em] biglg:mt-[-1em] lg:ml-[4em] biglg:ml-[2.3em] xl:ml-[-8em] lg:w-[350px] xl:w-[420px]'>
          <BudgetHistory getBudget={getBudget} hasHeader={false} />
          </div>
        </div>
      </div>

      <div className="xl:mt-[0.2em] xl:flex lg:gap-[2px] xl:gap-[13px] xl:flex-1  lg:flex lg:mt-[-0.9em] mt-[]  ">
        <div className=" mt-[1em] md:mt-[2em] 390:ml:[-2.7em] 375:ml-[-2.4em] 414:ml-[-1.3em] 360:ml-[-2.8em] 412:ml-[-1.3em] 540:ml-[-0.1em]  w-[350px] 540:w-[100%] md:w-[100%] md:h-[393px] md:ml-[0.2em] lg:mt-[] h-[280px] xl:mt-[1em] xl:pr-[10px] lg:w-[50%] biglg:w-[50%] xl:w-[50%] xl:flex md:flex-auto bg-white items-start xl:ml-[] lg:ml-[-0.2em] biglg:ml-[-0.2em]  ">
          <InvoicePieChart
            title="Invoice Status"
            trendtitle=""
            isLoaded={true}
            labelPosition="right"
            totalName="Total Categories"
            data={dashboardStats.invoiceStatuses as any}
            totalValue={dashboardStats.invoiceStatuses.totalPaidInvoices}
            innerCardWidth={500}
            innerCardHeight={350}
            pieChartInnerRadius={72}
          
          />
        </div>
        <div className=" mt-[1em] w-[350px] 540:w-[100%] 390:ml:[-2.7em] 375:ml-[-2.4em] 414:ml-[-1.3em] 360:ml-[-2.8em] 412:ml-[-1.3em] 540:ml-[-0.1em]   h-[280px] md:mt-[2em] md:w-[100%] md:h-[393px] md:ml-[0.2em] lg:w-[50%] lg:ml-[1em] lg:mt-[2em] xl:flex xl:w-[50%] xl:pr-[px] md:flex-auto xl:mt-[1em] xl:ml-[0.5em] bg-white ">
          <ExpensePieChart 
            title="Expense Categories"
            data={dashboardStats.expenseCategories}
            trendtitle=""
            totalName=""
            isLoaded={true}
            labelPosition="right"
            innerCardWidth={500}
            innerCardHeight={350}
            pieChartInnerRadius={72}
          />
        </div>
      </div>
      <>
      </>
      {hasData ? (
  <div id="scrollingContainer" className={`md:hidden mt-[1em] w-[500px] h-[328px] ml-[-3em] bg-white h-[100vh]" ${isSmallScreen() ? 'overflow-x-auto' : ''}`}>
    <div className="w-[px]">
      <BarChart
        title="Cashflow Trend"
        value="Last 12 Month"
        icon={''}
        data={dashboardStats.cashflowTrend.trend}
        offset={-10}
        datas={dashboardStats.cashflowTrend.trend}
        standalone={false}
        orientation="left"
        colorScale={dashboardStats.cashflowTrend.fill}
        isEmpty={false}
      />
    </div>
  </div>
) : (
  <div id="scrollingContainer" className={`md:hidden mt-[1em] w-[500px] h-[228px] ml-[-3em] bg-white h-[100vh]" ${isSmallScreen() ? 'overflow-x-auto' : ''}`}>
    <div className="w-[px]">
      <BarChart
        title="Cashflow Trend"
        value="Last 12 Month"
        icon={''}
        data={dashboardStats.cashflowTrend.trend}
        offset={-10}
        datas={dashboardStats.cashflowTrend.trend}
        standalone={false}
        orientation="left"
        colorScale={dashboardStats.cashflowTrend.fill}
        isEmpty={true}
      />
    </div>
  </div>
)}

{hasData ? (
  <div className="hidden sm:block mb-[2em] w-100% ml-[-2em] xl:mt-[1.7em] 540:w-[100%] xl:w-[100%] xl:pr-[33px] xl:ml-[0.1em] xl:h-[550px] 2xl:h-[540px] 3xl:h-[550px]   lg:mt-[2em] lg:ml-[0.1em] biglg:ml-[0.1em] md:mt-[2em] bigmd:h-[480px] md:w-[100%] md:h-[393px] md:ml-[0.2em] lg:w-[100%] x 2xl:w-[100%] bg-white h-[100vh]">
    <BarChart
      title="Cashflow Trend"
      value="Last 12 Month"
      icon={''}
      data={dashboardStats.cashflowTrend.trend}
      offset={-10}
      datas={dashboardStats.cashflowTrend.trend}
      standalone={false}
      orientation="left"
      colorScale={dashboardStats.cashflowTrend.fill}
      isEmpty={false}
    />
  </div>
) : (
  <div className="hidden sm:block w-100%  mb-[2em]  ml-[-2em] xl:mt-[1.7em]  540:w-[100%] xl:w-[100%] xl:pr-[33px] xl:ml-[0.1em] xl:h-[450px] biglg:h-[430px]  2xl:h-[540px] 3xl:h-[550px] lg:mt-[2em] lg:ml-[-1em] md:mt-[2em] md:w-[100%] md:h-[293px] bigmd:h-[280px] md:ml-[0.2em] lg:w-[100%] x 2xl:w-[100%] bg-white">
    <BarChart
      title="Cashflow Trend"
      value="Last 12 Month"
      icon={''}
      data={dashboardStats.cashflowTrend.trend}
      offset={-10}
      datas={dashboardStats.cashflowTrend.trend}
      standalone={false}
      orientation="left"
      colorScale={dashboardStats.cashflowTrend.fill}
      isEmpty={true}
    />
  </div>
)}
</div>
    </>
  );
};

